import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./auth/reducers";
import subscriptionReducer from "./subscription/reducers";
import tokensReducer from "./tokens/reducers";
import profileReducer from "./profile/reducers";
import characterReducer from "./characterSetting/reducers";
import languageReducer from "./language/reducers";
import tokenReducer from "./tokenpackage/reducers";
import faqReducer from "./faq/reducers";
import pageReducer from "./pages/reducers";
import userReducer from "./users/reducers";
import settingReducer from "./settings/reducer";
import transactionReducer from "./transaction/reducers";
import tagReducer from "./manageTag/reducer";
import homeReducer from "./homePage/reducer";
import characterListReducer from "./character/reducers";
import faqCategoryListReducer from "./faqCategory/reducers";
import RavenueListReducer from "./revenue/reducers";
import PaymentDataReducer from "./payments/reducers";
import SystemAccessReducer from "./system-access/reducers";
import characterPublicRequestReducer from "./characterPublicRequest/reducers";
import AppearanceReducer from "./appearance/reducers";
import CharacterStyleReducer from "./characterStyle/reducers";
import BlogCategoryReducer from "./blogCategory/reducers";
import BlogReducer from "./blogs/reducers";
import GiftReducer from "./gift/reducers";
import FlagMessageReducer from "./flagMessage/reducers";
import ContactFormReducer from "./contactForm/reducers";
import PromoCodeReducer from "./promoCode/reducers";
import featureSettingReducer from "./featureSetting/reducers";
import AffiliateReducer from "./affiliate/reducers";

const rootReducer = combineReducers({
  Auth: authReducer,
  Profile: profileReducer,
  Character: characterReducer,
  Language: languageReducer,
  Token: tokenReducer,
  Faq: faqReducer,
  Pages: pageReducer,
  User: userReducer,
  Subscription: subscriptionReducer,
  Tokens: tokensReducer,
  FeatureSetting: featureSettingReducer,
  Setting: settingReducer,
  Transaction: transactionReducer,
  Tag: tagReducer,
  Home: homeReducer,
  CharacterList: characterListReducer,
  FaqCategoryList: faqCategoryListReducer,
  RevenueList: RavenueListReducer,
  PaymentData: PaymentDataReducer,
  SystemAccessData: SystemAccessReducer,
  CharacterPublicRequest: characterPublicRequestReducer,
  Appearance: AppearanceReducer,
  CharType: CharacterStyleReducer,
  BlogCategory: BlogCategoryReducer,
  BlogList: BlogReducer,
  GiftList: GiftReducer,
  FlagMessageList: FlagMessageReducer,
  ContactFormList: ContactFormReducer,
  PromoCodeList: PromoCodeReducer,
  AffiliateContent: AffiliateReducer,
});

export default rootReducer;
